import React, { useCallback, useEffect, useRef, useState } from 'react';

// import {
//   Grid, 
// } from "@mui/material";

import { 
  Character,
  CharacterFeature,
  CharacterItem,
  CharacterSpell,
  CharacterSubrace,
  PseudoItem,
  Subrace,
  SummonOption2,
} from "@dndModels";
import { ModelBase } from "@models";

import DandDAPI from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  character: Character;
  obj: CharacterFeature;
  onChange: (changed: CharacterFeature) => void;
}

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterSubraceInput({
  character,
  obj,
  onChange,
}: Props) {
  const fos = obj.feature_options as CharacterSubrace[];
  const [fetched, setFetched] = useState(false);
  const [use_subraces, setUseSubraces] = useState<Subrace[]>([]);
  const [selected, setSelected] = useState(fos.filter(o => o.source_id !== "").map(o => o.source_id));
  const [changing, setChanging] = useState(false);
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setReloading(true);
  }, [setReloading]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = useCallback(() => {
    const subraces = data_util.subraces;
    // let ignore_us = character.subraces.filter(char_subrace => 
    //   char_subrace.source && !char_subrace.source.repeatable &&
    //   char_subrace.source_id !== obj.source_id).map(char_subrace => { return char_subrace.source_id; });
    let use_list = subraces; // .filter(o => !ignore_us.includes(o._id));
    if (!character.character_options.allow_monster_feature_sources) {
      use_list = use_list.filter(o => !o.monster);
    }
    const char_race = character.race;
    if (char_race) {
      use_list = use_list.filter(o => 
        (o.race_ids.includes(char_race.source_id) || common_util.anyOverlaps(o.race_ids,char_race.variant_ids)));
      use_list = use_list.filter(o => !character.character_options.blocked.includes(o._id));
      // use_list = use_list.sort((a,b) => {return a.name.localeCompare(b.name)});
      // filtered = api.filter("subrace", filtered, filter) as Subrace[];
    }
    // console.log(use_list);
    setUseSubraces(use_list);
  }, [character]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      load();
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    }
  }, [character, fetched, setFetched, mounted, recalculated, load]);

  const change = useCallback(async () => {
    const new_obj = obj;
    const new_fos = new_obj.feature_options as CharacterSubrace[];
    const removed = new_fos.filter(o => !selected.includes(o.source_id));
    const added = selected.filter(o => new_fos.filter(o2 => o2.source_id === o).length === 0);
    if (removed.length > 0) {
      for (const char_subrace of removed) {
        if (char_subrace.source) {
          // console.log(char_subrace);
          for (const char_item of character.items) {
            // console.log(char_item);
            char_item.char_feature_bases = char_item.char_feature_bases.filter(o => 
              o.ancestries.filter(o2 => o2.true_id === char_subrace.true_id).length === 0);
            for (const scfs of char_item.sub_char_feature_sources) {
              scfs.char_feature_bases = scfs.char_feature_bases.filter(o => 
                o.ancestries.filter(o2 => o2.true_id === char_subrace.true_id).length === 0);
            }
          }
          char_util.removeCharFeatureBasesFor(character, char_subrace);
          char_subrace.char_feature_bases = [];
          char_subrace.source_id = "";
          char_subrace.source_name = "";
          char_subrace.source_type = "";
          char_subrace.source = null;
        }
      }
      onChange(new_obj);
    }
    if (added.length > 0) {
      for (const id of added) {
        // Get an empty char_subrace and set the selected_subrace to it
        const char_subrace = new_fos.find(o => o.source_id === "");
        const selected_subrace = data_util.subraces.find(o => o._id === id);
        if (char_subrace && selected_subrace) {
          await api.loadObject(selected_subrace);
          char_subrace.copy_source({ char: character, feature_source: selected_subrace, parent_cf: obj });
        }
      }
      onChange(new_obj);
    }
  }, [character, obj, onChange, selected]);

  useEffect(() => {
    if (changing) {
      setChanging(false);
      // debugger;
      change();
    }
  }, [changing, setChanging, change]);


  if (!fetched) {
    return (<LoadingBox />);
  } else {
    return (
      <>
        <CharacterListOptionsInput
          data_type="subrace"
          character={character}
          choose_max={fos.length} 
          use_objects={use_subraces}
          selected={selected} 
          onChange={(changed: string[]) => {
            setSelected(changed);
            setChanging(true);
          }} 
          getDisabledReasons={(obj: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => {
            if (obj instanceof Subrace) {
              // if (obj.name.includes("Ascendant Step")) {
              //   debugger;
              // }
              const reasons = char_util.fitLimits(character, obj.limitations, "subrace", obj._id);
              return reasons === "true" ? "" : reasons;
            }
            return "";
          }}
        />
      </>
    );
  }
}
